const copyObject = (obj) => JSON.parse(JSON.stringify(obj));

export default (report, toRead, editReport = false) => {
  const currentYear = new Date().getFullYear();
  const yearFields = {
    actualYearReport: '',
  };
  const target = {
    membership: {
      individualMembers: copyObject(yearFields),
      individualMembersF: copyObject(yearFields),
      individualMembersM: copyObject(yearFields),
      nationalYoungCrewMembers: copyObject(yearFields),
      nationalYoungCrewMembersF: copyObject(yearFields),
      nationalYoungCrewMembersM: copyObject(yearFields),
      corporateMembers: copyObject(yearFields),
      activeVolunteers: copyObject(yearFields),
      membershipNotes: { notes: '' },
    },
    events: {
      eventsTotalParticipants: copyObject(yearFields),
      eventsNumberNonReg: copyObject(yearFields),
      eventsNotes: { notes: '' },
    },
    education: {
      regDiplomas: copyObject(yearFields),
      educationNotes: { notes: '' },
    },
  };

  let parsed = {};

  if (toRead) {
    Object.keys(target).forEach((category) => {
      Object.keys(target[category]).forEach((field) => {
        if (!field.includes('Notes')) {
          Object.keys(yearFields).forEach((year) => {
            target[category][field][year] = report[year][field];
          });
        } else {
          target[category][field] = report[field];
        }
      });
    });

    parsed = {
      items: {
        ...target,
      },
      actualYear: report.actualYear,
      version: report.version,
      maName: report.memberAssociation ? report.memberAssociation.name : '',
      kamNotes: report.kamNotes,
    };
  } else {
    Object.keys(target).forEach((category) => {
      Object.keys(target[category]).forEach((field) => {
        if (editReport) {
          if (!field.includes('Notes')) {
            Object.keys(yearFields).forEach((year) => {
              target[category][field][year] = report[year][field] ? report[year][field] : '';
            });
          } else {
            target[category][field].notes = report[field] ? report[field] : '';
          }
        } else if (!field.includes('Notes')) {
          if (currentYear === report.actualYear) {
            target[category][field].actualYearReport = report.actualYearReport[field]
              ? report.actualYearReport[field]
              : '';
          }
        }
      });
    });
    parsed = {
      ...target,
    };
  }

  return parsed;
};
